<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <add-template modal-id="add-template">
      <div slot="title">Add PBN Template</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <input type="text" class="form-control" placeholder="Name" v-model="modalTpl['name']">
          </div>
          <div class="col-lg-12 m-b-sm">
            <v-select :options="designStyles" placeholder="Design style" v-model="modalTpl['layout']"></v-select>
          </div>
          <div class="col-lg-12 m-b-sm">
            <v-select placeholder="Topic" :options="f.categories" v-model="modalTpl['topic']" taggable></v-select>
          </div>
          <div class="col-lg-12 m-b-sm">
            <button class="btn btn-sm btn-primary" @click="saveTemplate">Save Template</button>
          </div>
        </div>
      </div>
    </add-template>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Templates</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-template">Add</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>

import Form from '../../../Helpers/Modal/Form'
import List from './List'
import axios from 'axios'
import { TEMPLATES_SET } from '../../../../store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      modalTpl: {},
      designStyles: [
        'Basic Blog',
        'Premium Blog',
        'Premium Magazine',
        'Premium Business'
      ]
    }
  },
  mounted () {
    this.loadTemplates()
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  components: {
    addTemplate: Form,
    filters: [],
    list: List
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    saveTemplate () {
      axios.post('/pbn/template', this.modalTpl)
        .then(r => {
          this.$toastr.success('New pbn template successfully added', 'Success!')
          $('#add-template').modal('hide')
          this.modalTpl = {}
          this.loadTemplates()
        }).catch()
    },
    loadTemplates () {
      axios.get('/pbn/templates')
        .then(r => {
          this.$store.commit(TEMPLATES_SET, r.data.data)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Templates/Templates.vue